import { AUTH_CONSTANTS } from '../_MODULES/_API';
import { useForm } from '../../../../../_CORE/APP/Templates/_UI/Form/_index';
import { notify } from '../../../../../_CORE/APP/Templates/_UI/Alerts/AppAlertHost';
import { useApiActionMutation } from '../../../../../_CORE/APP/Hooks/Hooks/_Actions/_useApiActionMutation';
import { useReactNavigation } from '../../../../../_CORE/APP/Hooks/Hooks/useReactNavigation';
import { STORAGE_SESSION_HELPER } from '../../../../../_CORE/HELPERS/storageSession.helper';
import { APP_STORAGE } from '../../../../../_CORE/_Config/AppConfig.Storage';

export const useAuthLogin = () => {
    const { redirectTo } = useReactNavigation();

    const { actionMutate, useActionApiIsLoading } = useApiActionMutation({
        isToastError: true,
        minTimeMutate: 600,
        // Un 401 aqui significa credenciales incorrectas, no una sesion vencida.
        // Debe permanecer en /ingresar y mostrar el mensaje del backend.
        logoutOn401: false,
    });

    const FORM = useForm({
        initialValues: { email: '', password: '' },
        schema: {
            email: { required: true, email: true },
            password: { required: true },
        },
        onSubmit: async (values) => {
            const RESPONSE = await actionMutate({
                method: 'POST', endpoint: AUTH_CONSTANTS.LOGIN,
                data: { email: values.email.trim(), password: values.password },
            });

            if (!RESPONSE.success) return;

            if (RESPONSE.data?.requiresTwoFactor) {
                STORAGE_SESSION_HELPER.SET_SESSION_STORAGE(APP_STORAGE.AUTH_2FA_CHALLENGE, RESPONSE.data.challengeToken || '');
                STORAGE_SESSION_HELPER.SET_SESSION_STORAGE(APP_STORAGE.AUTH_2FA_EMAIL_MASKED, RESPONSE.data.emailMasked || '');
                STORAGE_SESSION_HELPER.SET_SESSION_STORAGE(APP_STORAGE.AUTH_2FA_EXPIRES, RESPONSE.data.expiresIn || '');
                notify.info('Verificacion en dos pasos', `Enviamos un codigo a ${RESPONSE.data.emailMasked || 'tu correo de seguridad'}.`);
                redirectTo('/verificar-codigo');
                return;
            }

            // Defensa adicional del cliente: este panel no admite acceso directo sin 2FA.
            notify.error('Segundo factor requerido', 'El servidor no solicito la verificacion en dos pasos. No se inicio la sesion.');
        },
    });

    return { FORM, isLoading: useActionApiIsLoading };
};
